<template>
    <div style="text-align: center">
        <v-container grid-list-md>
            <v-layout wrap centered>
                <v-flex xs12>
                    
                    <v-btn flat icon color="error" @click="removePoint"><v-icon>remove_circle_outline</v-icon></v-btn>
                    <v-btn flat icon color="info" @click="resetPoint"><v-icon>replay</v-icon></v-btn>
                    <br />
                    <v-btn fab outline large color="teal" @click="addPoint"><div style="font-size:45px">{{ points }}</div></v-btn>

                </v-flex>
            </v-layout>
        </v-container>
           
            <v-layout row justify-center>
                <v-dialog v-model="dialog" max-width="360px">
                    <v-btn flat slot="activator">{{ ( bTeam == 'true' && !customised ) ? 'Time B' : customName}}</v-btn>
                    <v-card>
                        <v-card-title>
                        <span class="headline">Digite nome do time</span>
                        </v-card-title>
                        <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field v-model="newName" label="Novo time" required :counter="counter"></v-text-field>
                            </v-flex>
                            </v-layout>
                        </v-container>
                        <small>*indica campos obrigatórios</small>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="dialog = false" @click="cancelChange">Cancelar</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="dialog = false" @click="changeTeamName">Alterar</v-btn>
                        </v-card-actions>
                    </v-card>
            </v-dialog>
        </v-layout>
    </div> 
</template>

<script>
export default {
    name: 'PtkTeamPoint',
    props: ['bTeam'],
    data: () => ({
       dialog: false,
       customised: false,
       points: 0,
       customName: 'Time A',
       newName: '',
       counter: 15
    }),
    methods:{
        addPoint(){
            this.points++
            this.$emit('added')
        },
        removePoint(){
            if(this.points > 0){
                this.points--
                this.$emit('reduced')
            }
        },
        resetPoint(){
            this.points = 0
            this.$emit('reseted')
        },
        changeTeamName(){
            this.customised = true
            this.customName = this.newName.substring(0,this.counter)
            if(this.customName == ""){
                this.customName = this.bTeam == "true" ? "Time B" : "Time A"
                this.customised = false
            } 
        },
        cancelChange(){
            this.newName = ''
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PtkTeamPoint.vue